import React from "react";

const Skeleton = () => {
  return (
    <div className="flex flex-col items-center gap-4">
      {/* Gauge skeleton - semicircle shape */}
      <div className="relative h-[112px] w-[183px]">
        <div className="h-[92px] w-[183px] animate-pulse rounded-t-full bg-gray-200" />
      </div>

      {/* Description skeleton */}
      <div className="h-4 w-48 animate-pulse rounded bg-gray-200" />

      <div className="h-px w-full bg-gray-200" />

      <div className="flex w-full flex-col gap-4">
        {/* Title skeleton */}
        <div className="h-5 w-48 animate-pulse rounded bg-gray-200" />

        {/* Tip item skeleton */}
        <div className="flex items-start gap-3">
          <div className="h-4 w-4 flex-shrink-0 animate-pulse rounded bg-gray-200" />
          <div className="flex flex-1 flex-col gap-2">
            <div className="h-4 w-32 animate-pulse rounded bg-gray-200" />
            <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
          </div>
        </div>

        {/* Carousel dots skeleton */}
        <div className="flex items-center justify-center gap-2">
          <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-gray-200" />
          <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-gray-200" />
          <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-gray-200" />
          <div className="h-1 w-1 animate-pulse rounded-full bg-gray-200" />
          <div className="h-0.5 w-0.5 animate-pulse rounded-full bg-gray-200" />
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
